import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalDialogActionButton } from './modal-dialog-action-button.model';
import { ModalDialogData } from './modal-dialog-data.model';

@Component({
    selector: 'diana-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    standalone: false
})
export class ModalDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogData,
    private mdDialogRef: MatDialogRef<ModalDialogComponent>
  ) { }

  cancel() {
    this.close(undefined);
  }

  onClose() {
    this.close(false);
  }

  close(value?: boolean) {
    this.mdDialogRef.close(value);
  }

  confirm() {
    this.close(true);
  }

  actionBtnClicked(actionBtn: ModalDialogActionButton) {
    actionBtn.action();
    this.close(true);
  }

  @HostListener('keydown.escape')
  onEscKeyPressed() {
    this.close(false);
  }
}
